export default {
  namespaced: true,
  state: {
    doCopyAction: false
  },
  mutations: {
    setCopyAction(state, payload) {
      state.doCopyAction = payload
    }
  },
  actions: {
    setCopyAction({ commit }, value) {
      commit('setCopyAction', value)
    }
  },
  getters: {
    doCopyAction: state => state.doCopyAction
  }
}
